module.exports = __webpack_public_path__ + "img/solar-panel.62a490c5.png";